import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  OnChanges,
  Output,
  SimpleChanges,
} from "@angular/core";

export interface CustomDropdownOption {
  label: string;
  value: string;
  color?: string;
  iconName?: string;
  iconClass?: string;
  bgColor?: string;
  subLabel?: string;
}

@Component({
  selector: "app-pho-custom-dropdown",
  templateUrl: "./pho-custom-dropdown.component.html",
  styleUrls: ["./pho-custom-dropdown.component.scss"],
})
export class PhoCustomDropdown implements OnInit, OnChanges {
  @Input() recommendation?: string;
  @Input() options: Array<CustomDropdownOption> = [];
  @Input() selectedValue?: string = "";
  @Input() btnDisable: boolean = false;
  @Output() actionBtnCallback = new EventEmitter<any>();

  ngOnInit(): void {
    if (this.selectedValue === "" && this.options.length) {
      this.selectedValue = this.options[0].value;
    }
  }
  ngOnChanges(changes: SimpleChanges): void {
    if (changes["options"]) {
      this.options = changes.options.currentValue;
    }
  }
  onValueChange(newValue: string) {
    this.selectedValue = newValue;
    this.actionBtnCallback.emit(newValue);
  }

  onOptionClick(value: string) {
    if (this.selectedValue === value) {
      this.actionBtnCallback.emit(value);
    } else {
      this.onValueChange(value);
    }
  }

  get selectedOption() {
    return this.options.find((opt) => opt.value === this.selectedValue);
  }

  isRecommended(option: { value: string }): boolean {
    return this.recommendation?.toLowerCase() === option.value.toLowerCase();
  }
}
